import * as _service from './api';

const actions = {
  async fetchResult({ commit }, filter) {
    const response = await _service.searchAt(filter);
    if (response) {
      commit('setResult', response);
    }
  },
};

export default actions;
